module.exports = __webpack_public_path__ + "img/玫瑰记忆座位框.87b1f0e6.png";